import React, { useRef, useState } from 'react';
import cogoToast from 'cogo-toast';
import ConfirmationVoucherTemplate from './ConfirmationVoucherTemplate';
import { exportConfirmationVoucherPdfFromElement } from './ConfirmationVoucherReport';
import './ConfirmationVoucherPreviewModal.css';

const ConfirmationVoucherPreviewModal = ({ show, data, onClose }) => {
    const voucherRef = useRef(null);
    const [isPdfGenerating, setIsPdfGenerating] = useState(false);

    const handlePrintPdf = async () => {
        const element = voucherRef.current?.querySelector('#confirmation-voucher-print-root');
        if (!element || !data?.header) return;

        setIsPdfGenerating(true);
        try {
            await exportConfirmationVoucherPdfFromElement(element, data.header);
        } catch {
            cogoToast.error('Failed to generate PDF', { position: 'bottom-center' });
        } finally {
            setIsPdfGenerating(false);
        }
    };

    if (!show || !data?.header) return null;

    return (
        <div className="modal show-modal modalWrapper confirmation-voucher-modal">
            <div className="modal-dialog confirmation-voucher-modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>Confirmation Voucher</h3>
                        <i
                            className="fa-regular fa-circle-xmark text-danger"
                            onClick={onClose}
                            role="button"
                            aria-label="Close"
                        />
                    </div>

                    <div className="modal-body confirmation-voucher-modal-body" ref={voucherRef}>
                        <div className="confirmation-voucher-preview-frame">
                            <ConfirmationVoucherTemplate
                                header={data.header}
                                lineItems={data.lineItems}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={handlePrintPdf}
                            disabled={isPdfGenerating}
                        >
                            {isPdfGenerating ? 'Generating...' : 'Print as PDF'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                            disabled={isPdfGenerating}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationVoucherPreviewModal;
